import { JpCoBenefitoneBsSubsidyDtoErrorData } from '@/openapi/order';

export default class ApiService {
  static isErrorData(arg: unknown): arg is JpCoBenefitoneBsSubsidyDtoErrorData {
    return typeof arg === 'object' &&
      arg !== null &&
      typeof (arg as JpCoBenefitoneBsSubsidyDtoErrorData).errorCode === 'string' &&
      typeof (arg as JpCoBenefitoneBsSubsidyDtoErrorData).errorDetail === 'string';
  }
}
